import { render, staticRenderFns } from "./prop_folder.vue?vue&type=template&id=08398cbe&scoped=true&lang=pug&"
import script from "./prop_folder.vue?vue&type=script&lang=js&"
export * from "./prop_folder.vue?vue&type=script&lang=js&"
import style0 from "./prop_folder.vue?vue&type=style&index=0&id=08398cbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08398cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08398cbe', component.options)
    } else {
      api.reload('08398cbe', component.options)
    }
    module.hot.accept("./prop_folder.vue?vue&type=template&id=08398cbe&scoped=true&lang=pug&", function () {
      api.rerender('08398cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop_panel/component/prop_folder.vue"
export default component.exports